import {Component, Input, OnInit} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {StudiosService} from '../../../services/studios.service';
import {ProfileService} from '../../../services/profile.service';
import {HelperService} from '../../../services/helper.service';


@Component({
  selector: 'app-tn-studio-card',
  templateUrl: './tn-studio-card.component.html',
  styleUrls: ['./tn-studio-card.component.scss']
})
export class TnStudioCardComponent implements OnInit {

  @Input() studio;
  @Input() queryParams?: any;

  public env = environment;
  public studioAddress = '';
  public showCover = true;
  public studioRating: number;
  public studioOffers;
  coverImageLoading = true;

  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private studioService: StudiosService,
      private profileService: ProfileService,
      private helperService: HelperService,
  ) {
  }

  ngOnInit(): void {
    this.studioService.mapStudioData(this.studio);
    this.studioAddress = this.studio.studioAddress;
    this.studioOffers = this.getBestOffers();

    const studioReviews = this.studio.studioReviews;
    if (studioReviews && studioReviews.length > 0) {
      this.studioRating = studioReviews.reduce((sum: any, { rating }: any) => sum + rating, 0) / studioReviews.length;
    }
  }

  seeStudioDetails() {
    let params = this.queryParams;
    if (!params) {
      params = this.route.snapshot.queryParams;
    }
    this.router.navigate(['/studio' , this.studio.slug || this.studio.id], { queryParams: params });
  }

  userHasLoggedIn(): boolean{
    return Object.keys(this.profileService.getUserData()).length !== 0;
  }

  studioHasService(serviceType: string): boolean {
    return this.studio.rooms.some(room =>
      room.services.some(service => service.type === serviceType)
    );
  }

  getCurrency() {
    return this.helperService.getCurrencySymbol(this.studio.businessCurrency ? this.studio.businessCurrency : 'EUR');
  }

  getBestOffers() {
    const res = { percentage: -1, amount: {cutoff: -1, payoff: 0, final: 0} };
    this.studio.rooms.map(room => {
      room.services.filter(service => !service.isDeleted).map(service => {
        const hourlyRate = service.price;
        service.discounts.map(discount => {
          if (discount.type === 'percentage') {
            if (discount.rules.percentage > res.percentage) {
              res.percentage = discount.rules.percentage;
            }
          }
          if (discount.type === 'amount') {
            const {cutoff, payoff } = discount.rules;
            if (cutoff > res.amount.cutoff) {
              res.amount = {
                cutoff,
                payoff,
                final: (cutoff * hourlyRate) - payoff
              };
            }
          }
        });
      });
    });
    return res;
  }
}
